/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolStormIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-storm"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M19.8 22.75Q19.3 22.75 19.02 22.31Q18.75 21.88 18.93 21.38Q19.3 20.2 19.48 18.99Q19.65 17.77 19.6 16.55Q18.4 18.55 16.38 19.65Q14.35 20.75 12 20.75Q9.7 20.75 7.81 19.69Q5.92 18.63 4.58 16.86Q3.23 15.1 2.49 12.81Q1.75 10.53 1.75 8.05Q1.75 6.67 1.89 5.33Q2.02 3.98 2.38 2.65Q2.55 2.02 3.05 1.64Q3.55 1.25 4.2 1.25Q4.7 1.25 4.99 1.69Q5.28 2.13 5.1 2.63Q4.72 3.8 4.54 5.01Q4.35 6.22 4.4 7.45Q5.6 5.45 7.63 4.35Q9.65 3.25 12 3.25Q14.3 3.25 16.19 4.3Q18.07 5.35 19.43 7.11Q20.77 8.88 21.51 11.18Q22.25 13.47 22.25 15.95Q22.25 17.32 22.11 18.68Q21.98 20.02 21.63 21.35Q21.45 21.98 20.95 22.36Q20.45 22.75 19.8 22.75ZM12 16.7Q12 16.7 12.97 16.7Q13.95 16.7 15.32 15.32Q16.7 13.95 16.7 12Q16.7 10.05 15.32 8.68Q13.95 7.3 12 7.3Q10.05 7.3 8.68 8.68Q7.3 10.05 7.3 12Q7.3 13.95 8.68 15.32Q10.05 16.7 12 16.7ZM12 14.05Q12 14.05 11.57 14.05Q11.15 14.05 10.55 13.45Q9.95 12.85 9.95 12Q9.95 11.15 10.55 10.55Q11.15 9.95 12 9.95Q12.85 9.95 13.45 10.55Q14.05 11.15 14.05 12Q14.05 12.85 13.45 13.45Q12.85 14.05 12 14.05Z" fill={color} />
    </svg>
  );
}
